import {
  DatetimePicker as _DatetimePicker,
  DatetimePickerDate,
  DatetimePickerTime,
} from "./datetime-picker";

export const DatetimePicker = Object.assign(_DatetimePicker, {
  Date: DatetimePickerDate,
  Time: DatetimePickerTime,
});
